module.exports = __webpack_public_path__ + "media/images/SKYSHARE-7c9457acffe0c0c7779a115918bcd9dd.svg";